<template>
  <router-view></router-view>
</template>

<script>

export default {
  async beforeCreate() {
    this.trans.set
    if (this.$cookies.isKey('jwt')) {
      await this.axios.get('/sanctum/csrf-cookie').then(async(response) => {
        await this.axios.get(`/api/profile`)
            .then(response=>{
              this.$root.user = response.data.user;
              window.Laravel.jsPermissions = response.data.permissions;
              this.$emit('rootUserData')
            })
            .catch(error=>{
              this.$cookies.remove('jwt')
              delete window.axios.defaults.headers.common["Authorization"];
              this.$root.user = null;
              window.Laravel.jsPermissions = {};
              this.$router.push({name:'login'})
            });
      });
    }
  }
};
</script>
